export default "__VITE_ASSET__BG0ydm0j__"